module.exports = __webpack_public_path__ + "img/alipay_qr.57df9889.png";